import { url, tokenRef } from "api";

const headers = () => {
  const h = { "Content-Type": "application/json" };
  const t = localStorage.getItem(tokenRef);
  if (t) h["Authorization"] = `Bearer ${t}`;
  return h;
};

const handle = async (r) => {
  const d = await r.json();
  if (!r.ok) {
    const e = new Error(d.err || "Request failed");
    e.status = r.status;
    throw e;
  }
  return d;
};

// Partner orgs this admin may administer, with their projects and flags.
export const getPartnerCompanies = async () =>
  handle(await fetch(`${url}/partner-admin/companies`, { headers: headers() }));

// Promote a partner org to a paying company.
export const convertPartnerCompany = async (companyId, body = {}) =>
  handle(await fetch(`${url}/partner-admin/companies/${companyId}/convert`, {
    method: "POST", headers: headers(), body: JSON.stringify(body),
  }));

// What a contractor may do on the owner's project. Everything they
// create still waits in the Review Center before it goes live.
export const setPartnerGrants = async (participantId, grants) =>
  handle(await fetch(`${url}/partner-admin/grants`, {
    method: "PATCH", headers: headers(), body: JSON.stringify({ participantId, grants }),
  }));

// Grant / revoke a partner's right to maintain their own plan rows.
export const setPartnerPlanEdit = async (participantId, allow) =>
  handle(await fetch(`${url}/partner-admin/plan-edit`, {
    method: "PATCH", headers: headers(), body: JSON.stringify({ participantId, allow }),
  }));
